import { ReactElement } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaTimes } from 'react-icons/fa';

interface TwoFactorReminderModalProps {
    show: boolean;
    onActivate: () => void;
    onDismiss: () => void;
}

const TwoFactorReminderModal = ({ show, onActivate, onDismiss }: TwoFactorReminderModalProps): ReactElement => {
    return (
        <Modal
            show={show}
            onHide={onDismiss}
            centered
            backdrop="static"
            className="reminder-2fa-modal"
        >
            <Modal.Header className="border-0 pb-2" style={{
                background: 'linear-gradient(135deg, #00a854 0%, #008042 100%)',
                padding: '1.5rem',
                position: 'relative'
            }}>
                <Button
                    variant="link"
                    onClick={onDismiss}
                    className="position-absolute top-0 end-0 text-white p-0 m-2"
                    style={{ opacity: 0.9, zIndex: 10 }}
                >
                    <FaTimes size={18} />
                </Button>
                <div className="w-100">
                    <h4 className="text-white fw-bold mb-1" style={{ fontSize: '20px' }}>
                        Protege tu Cuenta
                    </h4>
                    <p className="text-white mb-0" style={{ opacity: 0.9, fontSize: '0.9rem' }}>
                        Activa la autenticación de dos factores
                    </p>
                </div>
            </Modal.Header>

            <Modal.Body className="p-4">
                <p style={{ fontSize: '0.95rem', color: '#495057', lineHeight: '1.6', marginBottom: '1rem' }}>
                    La autenticación de dos factores (2FA) añade una capa adicional de seguridad a tu cuenta,
                    protegiendo tus datos incluso si alguien obtiene tu contraseña.
                </p>

                <div
                    className="p-3 mb-3"
                    style={{
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                    }}
                >
                    <p className="mb-2" style={{ fontSize: '0.9rem', color: '#495057', fontWeight: '600' }}>
                        ¿Por qué activar 2FA?
                    </p>
                    <ul className="mb-0 ps-3" style={{ fontSize: '0.85rem', color: '#6c757d' }}>
                        <li>Mayor seguridad para tu cuenta</li>
                        <li>Protección contra accesos no autorizados</li>
                        <li>Solo toma unos minutos configurarlo</li>
                    </ul>
                </div>

                <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '0' }}>
                    Puedes activarlo ahora o más tarde desde la configuración de tu cuenta.
                </p>
            </Modal.Body>

            <Modal.Footer className="border-0 pt-0 pb-3 px-4">
                <div className="w-100 d-flex gap-2">
                    <Button
                        variant="outline-secondary"
                        onClick={onDismiss}
                        className="flex-fill"
                        style={{
                            borderRadius: '8px',
                            padding: '10px',
                            fontWeight: '600',
                            fontSize: '0.9rem',
                            border: '1px solid #dee2e6'
                        }}
                    >
                        Más tarde
                    </Button>
                    <Button
                        onClick={onActivate}
                        className="flex-fill"
                        style={{
                            background: 'linear-gradient(135deg, #008042 0%, #00a854 100%)',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '10px',
                            fontWeight: '600',
                            fontSize: '0.9rem',
                            boxShadow: '0 2px 8px rgba(0, 128, 66, 0.25)'
                        }}
                    >
                        Activar Ahora
                    </Button>
                </div>
            </Modal.Footer>

            <style>{`
                .reminder-2fa-modal .modal-content {
                    border-radius: 16px;
                    overflow: hidden;
                    border: none;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
                }
                
                .reminder-2fa-modal .btn:hover {
                    transform: translateY(-1px);
                    transition: all 0.2s ease;
                }
                
                .reminder-2fa-modal .btn:active {
                    transform: translateY(0);
                }
            `}</style>
        </Modal>
    );
};

export default TwoFactorReminderModal;
